<template>
  <div class="date-range-range">
    <div class="date-range-range__item">
      <div v-if="!hideTitle" class="date-range-range__item-label">
        {{ title }}
      </div>
      <el-date-picker
        v-model="inputValue"
        :editable="false"
        :clearable="clearable"
        :disabled="disabled"
        type="daterange"
        unlink-panels
        start-placeholder="Начало"
        end-placeholder="Окончание"
        :default-value="new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate())"
        format="DD.MM.YYYY"
        :picker-options="fullPickerOptions">
        <template #range-separator>
          <div class="date-range-range__icon">
            <el-icon>
              <Right/>
            </el-icon>
          </div>
        </template>
      </el-date-picker>
    </div>
  </div>
</template>

<script>
import { ElDatePicker } from 'element-plus'

export default {
  name: 'TableDateRange',
  components: {
    ElDatePicker
  },
  props: {
    modelValue: Array,
    hideTitle: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Расчетный период'
    },
    pickerOptions: {
      type: Object,
      default: () => {}
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: null
    }
  },
  computed: {
    fullPickerOptions() {
      return {
        firstDayOfWeek: 1,
        disabledDate: time => time.getTime() > Date.now(),
        ...this.pickerOptions
      }
    }
  },
  watch: {
    modelValue(period) {
      this.inputValue = !period ? null : period
    },
    inputValue: {
      deep: true,
      handler(value) {
        this.$emit('update:model-value', value)
      }
    }
  },
  beforeMount() {
    if (!this.modelValue) return
    this.inputValue = [...this.modelValue]
  }
}
</script>

<style scoped>

</style>
